import { Badge, Button } from 'react-bootstrap'
import { useQsFilters } from '../../hooks/filters'
import StickyTable from '../../components/StickyTable'
import {
  useCreateEsportazione,
  useEsportazioniList,
} from '../../hooks/esportazioni'
import Sorter, { SortControl } from '../../components/Sorter'
import Paginator from '../../components/Paginator'
import dayjs from 'dayjs'
import { API_URL, STATI_ESPORTAZIONE } from '../../constants'
import { Link, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import ModalInterventiEsportazione from '../EsportazioneDettaglio/ModalInterventiEsportazione'
import { useEffect, useState } from 'react'
import { fetchApiJson } from '@inmagik/react-crud'
import { useAuth } from '../../auth'
import ListFilters from '../../components/ListFilters'
import DateRangeField from '../../components/DateRangeField'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? '-pk',
  min_data_intervento_gte: params.get('min_data_intervento_gte') ?? '',
  max_data_intervento_lte: params.get('max_data_intervento_lte') ?? '',
  stato: params.get('stato') ?? '',
})

export default function Esportazioni() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)
  const esportazioni = useEsportazioniList({
    search: filters.search,
    ordering: filters.ordering,
    page: String(filters.page),
    min_data_intervento__gte: filters.min_data_intervento_gte,
    max_data_intervento_lte: filters.max_data_intervento_lte,
    stato: filters.stato,
  })

  const { mutateAsync: createEsportazione, isPending } = useCreateEsportazione()

  const [modalStateEsportazione, modalActionsEsportazione] = useModalTrigger()

  const router = useNavigate()

  const [numInterventiEsporazione, setNumInterventiEsporazione] = useState(0)

  const { tokens } = useAuth()

  useEffect(() => {
    fetchApiJson(
      `${API_URL}/bilance/esportazione/numero-interventi-esportabili/`,
      {
        headers: {
          Authorization: `Bearer ${tokens?.access}`,
        },
      }
    ).then((data) => {
      setNumInterventiEsporazione(data.numero_interventi)
    })
  }, [])

  return (
    <div className="page page-list">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between list-header">
          <h1 className="title">Esportazioni</h1>
          <div className="d-flex align-items-center list-header-actions">
            <Badge bg="primary" className="me-2">
              {numInterventiEsporazione}
              {numInterventiEsporazione === 1
                ? ' intervento esportabile'
                : ' interventi esportabili'}
            </Badge>
            <Button
              onClick={async () => {
                modalActionsEsportazione.open()
              }}
              variant="secondary"
              className="text-white d-flex align-items-center"
              type="button"
            >
              <span className="btn-label">Crea esportazione</span>
              <span className="material-icons ms-2">add</span>
            </Button>
          </div>
        </div>
        <div className="col-12">
          <div className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded list-toolbar">
            <ListFilters active={filters.stato !== '' || filters.min_data_intervento_gte !== ''}>
              <div className="d-flex align-items-center">
                <label className="label-m text-body-secondary me-2">
                  Periodo
                </label>
                <DateRangeField
                  start={filters.min_data_intervento_gte}
                  end={filters.max_data_intervento_lte}
                  placeholder="Seleziona periodo"
                  onChange={(start, end) => setFilters({ min_data_intervento_gte: start, max_data_intervento_lte: end, page: 1 })}
                />
              </div>
              <div className="d-flex align-items-center ms-2">
                <label className="label-m text-body-secondary">Stato</label>
                <select
                  className={classNames('form-select ms-2 text-secondary', {
                    'text-secondary': uiFilters.stato !== '',
                  })}
                  style={{ width: '170px' }}
                  value={uiFilters.stato}
                  onChange={(e) =>
                    setFilters({ stato: e.target.value, page: 1 })
                  }
                >
                  <option value="">Tutti</option>
                  {STATI_ESPORTAZIONE.map((stato) => (
                    <option key={stato.value} value={stato.value}>
                      {stato.label}
                    </option>
                  ))}
                </select>
              </div>
            </ListFilters>
            <div className="me-2 text-nowrap list-count">
              Stai visualizzando {esportazioni?.data?.count ?? 0} di{' '}
              {esportazioni?.data?.full_count ?? 0} esportazioni
            </div>
          </div>
          <StickyTable isLoading={esportazioni?.isLoading}>
            <thead className="position-sticky top-0 bg-white">
              <Sorter
                value={uiFilters.ordering}
                onSortChange={(ordering) =>
                  setFilters({
                    ordering,
                  })
                }
              >
                <tr>
                  <th>
                    <div className="d-flex align-items-center">
                      Id esportazione
                      <SortControl field="id" />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">
                      Data
                      <SortControl field="data" />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">
                      Numero pratica
                      <SortControl field="numero_pratica" />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">Province</div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">
                      Numero interventi
                      <SortControl field="numero_interventi" />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">Periodo</div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">
                      Stato
                      <SortControl field="stato" />
                    </div>
                  </th>
                </tr>
              </Sorter>
            </thead>
            <tbody>
              {esportazioni.data?.count === 0 && (
                <tr>
                  <td colSpan={5} className="text-center">
                    Nessuna esportazione disponibile
                  </td>
                </tr>
              )}
              {esportazioni?.data?.results?.map((esportazione) => (
                <tr key={esportazione.id}>
                  <td>
                    <Link
                      to={`/esportazioni/${esportazione.id}`}
                      className="link-md"
                    >
                      {esportazione.id}
                    </Link>
                  </td>
                  <td>
                    {esportazione.data
                      ? dayjs(esportazione.data).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td>
                    {esportazione.numero_pratica && (
                      <Badge color="primary">
                        {esportazione.numero_pratica}
                      </Badge>
                    )}
                  </td>
                  <td>{esportazione?.province}</td>
                  <td>{esportazione.numero_interventi}</td>
                  <td>
                    {esportazione.min_data_intervento &&
                    esportazione.max_data_intervento
                      ? `${dayjs(esportazione.min_data_intervento).format(
                          'DD/MM/YYYY'
                        )} - ${dayjs(esportazione.max_data_intervento).format(
                          'DD/MM/YYYY'
                        )}`
                      : ''}
                  </td>
                  <td>
                    {STATI_ESPORTAZIONE.find(
                      (s) => s.value === esportazione.stato
                    )?.label ?? esportazione.stato}
                  </td>
                </tr>
              ))}
            </tbody>
          </StickyTable>

          <Paginator
            count={esportazioni?.data?.count ?? 0}
            currentPage={uiFilters.page}
            goToPage={(page) => setFilters({ page })}
          />
        </div>
      </div>
      {modalStateEsportazione.isOpen && (
        <ModalInterventiEsportazione
          isOpen={modalStateEsportazione.isOpen}
          title="Crea esportazione"
          isPending={isPending}
          toggle={modalActionsEsportazione.close}
          save={async ({ interventi }) => {
            await createEsportazione({
              stato: 'creata',
              interventi,
            }).then((esportazione) => {
              modalActionsEsportazione.close()
              router(`/esportazioni/${esportazione.id}`)
            })
          }}
        />
      )}
    </div>
  )
}
